import React from 'react';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { getText } from 'services/languageService';

export const HomeElement: React.FC = (): JSX.Element => {
  return (
    <TooltipMapIcon title={getText('EXTENT_TL')}>
      <MapElementIcon>
        <IconButton aria-label="home" id="extent-btn">
          <HomeIcon />
        </IconButton>
      </MapElementIcon>
    </TooltipMapIcon>
  );
};
